import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link as ReactLink } from 'react-router-dom';
import clsx from 'clsx';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import isInternalLink from '@dashboard/services/isInternalLink';

const propTypes = {
  to: PropTypes.string.isRequired,
  blank: PropTypes.bool,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  blank: false,
  color: '',
  hoverColor: '',
  className: '',
};

export function getLinkClass(size, variant, bare, external) {
  return clsx('transition-colors font-medium cursor-pointer', {
    'inline-flex items-center gap-x-2 mr-auto md:mr-0': variant === 'withIcon' || external,
    'text-foreground hover:text-muted-foreground': !bare && variant !== 'secondary',
    'underline hover:text-gray-700 dark:hover:text-muted-foreground': variant === 'secondary',
    'underline text-white hover:text-gray-200': variant === 'light',
    '': size === 'small',
  });
}
// variants = external || withIcon || underline

class LinkElement extends Component {
  render() {
    const {
      to,
      href,
      children,
      blank,
      className,
      variant,
      bare,
      size,
      external = false,
      innerRef,
      ...rest
    } = this.props;
    const isInternal = isInternalLink(to || href);
    // A mailto/tel href keeps the address readable in a session replay even though text is masked.
    const contactHref = /^(mailto|tel):/i.test(to || href || '');
    const linkClass = clsx(
      'transition-colors font-medium',
      className,
      getLinkClass(size, variant, bare, external),
      { 'ph-no-capture': contactHref },
    );

    if (isInternal && !blank) {
      return (
        <ReactLink ref={innerRef} className={linkClass} to={href || to} {...rest}>
          {children}

          {external && <ArrowTopRightOnSquareIcon className="w-4 h-4" />}
        </ReactLink>
      );
    }

    return (
      <a
        ref={innerRef}
        className={linkClass}
        href={href || to}
        target={blank ? '_blank' : ''}
        rel="noopener noreferrer"
        {...rest}
      >
        {children}

        {external && <ArrowTopRightOnSquareIcon className="w-4 h-4" />}
      </a>
    );
  }
}

LinkElement.propTypes = propTypes;
LinkElement.defaultProps = defaultProps;

// Radix `asChild` triggers put their ref on this element and later call focus() on it, which a
// class instance does not have (CHECKOUT-PAGE-FRONTEND-5R6), so the ref goes to the anchor.
const Link = React.forwardRef((props, ref) => <LinkElement {...props} innerRef={ref} />);

export default Link;
